<div
  id="uzd-protocol"
  [ngStyle]="{'font-size.px': options.fontSize}"
  class="blank-layout">

  <h4 class="title">
    {{ options.title }}
  </h4>

  <form [formGroup]="form">
    <div class="clr-row">
      <div class="clr-col-sm-12">
        <input [ngStyle]="{ 'font-size.px': options.fontSize }" clrInput formControlName="one_date" />
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">П.І.Б:</label>
          <input autocomplete="off"
                 [ngStyle]="{ 'font-size.px': options.fontSize }"
                 placeholder="" clrInput name="name" formControlName="one_pib" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">OM:</label>
          <input autocomplete="off"
                 [ngStyle]="{ 'font-size.px': options.fontSize }"
                 placeholder="" clrInput name="name" formControlName="one_om" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">По гестації:</label>
          <input autocomplete="off"
                 [ngStyle]="{ 'font-size.px': options.fontSize }"
                 placeholder="" clrInput name="name" formControlName="one_gastatsia" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Термін пологів:</label>
          <input autocomplete="off"
                 [ngStyle]="{ 'font-size.px': options.fontSize }"
                 placeholder="" clrInput name="name" formControlName="one_termin" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-select-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Методика сканування:</label>
          <select [ngStyle]="{ 'font-size.px': options.fontSize }" clrSelect name="options" formControlName="one_method">
            <option value="трансабдомінальна">трансабдомінальна</option>
            <option value="трансвагінальна">трансвагінальна</option>
          </select>
        </clr-select-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12">
        <div class="text-center-container text-left bold-text">
          <strong>Розміри матки:</strong>
        </div>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">довжина:</label>
          <input autocomplete="off"
                 [ngStyle]="{ 'font-size.px': options.fontSize }"
                 placeholder="" clrInput name="name" formControlName="one_dovz" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">ширина:</label>
          <input autocomplete="off"
                 [ngStyle]="{ 'font-size.px': options.fontSize }"
                 placeholder="" clrInput name="name" formControlName="one_shuruna" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">передньо-задній:</label>
          <input autocomplete="off"
                 [ngStyle]="{ 'font-size.px': options.fontSize }"
                 placeholder="" clrInput name="name" formControlName="one_pered_zad" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Структура біометрію:</label>
          <input autocomplete="off"
                 [ngStyle]="{ 'font-size.px': options.fontSize }"
                 placeholder="" clrInput name="name" formControlName="one_structura_biomentiyu" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-select-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Тонус біометрію:</label>
          <select [ngStyle]="{ 'font-size.px': options.fontSize }" clrSelect name="options" formControlName="one_tonus">
            <option value="не підвищений">не підвищений</option>
            <option value="підвищений по передній стінці">підвищений по передній стінці</option>
            <option value="підвищений по задній стінці">підвищений по задній стінці</option>
          </select>
        </clr-select-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">локальний гіпертонус:</label>
          <input autocomplete="off"
                 [ngStyle]="{ 'font-size.px': options.fontSize }"
                 placeholder="" clrInput name="name" formControlName="one_local_hipertonus" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">У порожнині матки візуалізується:</label>
          <input autocomplete="off"
                 [ngStyle]="{ 'font-size.px': options.fontSize }"
                 placeholder="" clrInput name="name" formControlName="one_u_poroz_vizial" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Діаметр плідного яйця:</label>
          <input autocomplete="off"
                 [ngStyle]="{ 'font-size.px': options.fontSize }"
                 placeholder="" clrInput name="name" formControlName="one_diamert_egg" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-select-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Кількість ембріонів:</label>
          <select [ngStyle]="{ 'font-size.px': options.fontSize }" clrSelect name="options" formControlName="one_kilkist_embrioniv">
            <option value="один">один</option>
            <option value="два">два</option>
            <option value="три">три</option>
          </select>
        </clr-select-container>
      </div>
    </div>

    <div class="clr-row button-row">
      <div class="clr-col-sm-12 button-left">
        <button class="btn btn-primary" (click)="copyDataToTextArea('не визначаються', 'one_vidsharuvannya')"> не визначаються </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('визначаються у області', 'one_vidsharuvannya')"> визначаються у області </button>
      </div>
      <div class="clr-col-sm-12 full-width-input">
        <clr-textarea-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Ділянки відшарування плідного яйця:</label>
          <textarea [ngStyle]="{ 'font-size.px': options.fontSize }" clrTextarea name="description" formControlName="one_vidsharuvannya"></textarea>
        </clr-textarea-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12">
        <div class="text-center-container text-left bold-text">
          <strong>Біометрія плоду</strong>
        </div>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Куприко-тім'яний розмір (КТР):</label>
          <input autocomplete="off"
                 [ngStyle]="{ 'font-size.px': options.fontSize }"
                 placeholder="" clrInput name="name" formControlName="one_kupriko" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Біпарієтальний розмір(БПР):</label>
          <input autocomplete="off"
                 [ngStyle]="{ 'font-size.px': options.fontSize }"
                 placeholder="" clrInput name="name" formControlName="one_biparietal" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-select-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Кістки черепа:</label>
          <select [ngStyle]="{ 'font-size.px': options.fontSize }" clrSelect name="options" formControlName="one_skull_bones">
            <option value="візуалізуються">візуалізуються</option>
            <option value="не візуалізуються">не візуалізуються</option>
          </select>
        </clr-select-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Окружність живота:</label>
          <input autocomplete="off"
                 [ngStyle]="{ 'font-size.px': options.fontSize }"
                 placeholder="" clrInput name="name" formControlName="one_okruznist" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Середній діаметр живота:</label>
          <input autocomplete="off"
                 [ngStyle]="{ 'font-size.px': options.fontSize }"
                 placeholder="" clrInput name="name" formControlName="one_ser_diametr" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Довжина стегна:</label>
          <input autocomplete="off"
                 [ngStyle]="{ 'font-size.px': options.fontSize }"
                 placeholder="" clrInput name="name" formControlName="one_dov_stegna" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Комірцевий простір:</label>
          <input autocomplete="off"
                 [ngStyle]="{ 'font-size.px': options.fontSize }"
                 placeholder="" clrInput name="name" formControlName="one_komirts_prostir" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Наявність носової кістки:</label>
          <input autocomplete="off"
                 [ngStyle]="{ 'font-size.px': options.fontSize }"
                 placeholder="" clrInput name="name" formControlName="one_nose_kist" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Серце:</label>
          <input autocomplete="off"
                 [ngStyle]="{ 'font-size.px': options.fontSize }"
                 placeholder="" clrInput name="name" formControlName="one_hearth" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Серцебиття:</label>
          <input autocomplete="off"
                 [ngStyle]="{ 'font-size.px': options.fontSize }"
                 placeholder="" clrInput name="name" formControlName="one_hearth_bom" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">ЧСС:</label>
          <input autocomplete="off"
                 [ngStyle]="{ 'font-size.px': options.fontSize }"
                 placeholder="" clrInput name="name" formControlName="one_chss" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Передня черевна стінка:</label>
          <input autocomplete="off"
                 [ngStyle]="{ 'font-size.px': options.fontSize }"
                 placeholder="" clrInput name="name" formControlName="one_pered_cherevna" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-select-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Рухова активність плода:</label>
          <select [ngStyle]="{ 'font-size.px': options.fontSize }" clrSelect name="options" formControlName="one_ruh_ploda">
            <option value="нормальна">нормальна</option>
            <option value="знижена">знижена</option>
            <option value="відсутня">відсутня</option>
          </select>
        </clr-select-container>
      </div>
    </div>

    <div class="clr-row button-row">
      <div class="clr-col-sm-12 button-left">
        <button class="btn btn-primary" (click)="copyDataToTextArea('передня', 'one_local_horionu')">передня</button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('задня', 'one_local_horionu')">задня</button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('дно', 'one_local_horionu')">дно</button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('права', 'one_local_horionu')">права</button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('ліва', 'one_local_horionu')">ліва</button>
        <button class="btn btn-primary" (click)="copyDataToTextArea('бокова', 'one_local_horionu')">бокова</button>
      </div>
      <div class="clr-col-sm-12 full-width-input">
        <clr-textarea-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Локалізація хоріону:</label>
          <textarea [ngStyle]="{ 'font-size.px': options.fontSize }" clrTextarea name="description" formControlName="one_local_horionu"></textarea>
        </clr-textarea-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">товщина:</label>
          <input autocomplete="off"
                 [ngStyle]="{ 'font-size.px': options.fontSize }"
                 placeholder="" clrInput name="name" formControlName="one_tovshuna" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">структура:</label>
          <input autocomplete="off"
                 [ngStyle]="{ 'font-size.px': options.fontSize }"
                 placeholder="" clrInput name="name" formControlName="one_structura" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Шийка матки:</label>
          <input autocomplete="off"
                 [ngStyle]="{ 'font-size.px': options.fontSize }"
                 placeholder="" clrInput name="name" formControlName="one_shuyka" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Цервікальний канал:</label>
          <input autocomplete="off"
                 [ngStyle]="{ 'font-size.px': options.fontSize }"
                 placeholder="" clrInput name="name" formControlName="one_tserv_canal" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Діаметр внутрішнього вічка:</label>
          <input autocomplete="off"
                 [ngStyle]="{ 'font-size.px': options.fontSize }"
                 placeholder="" clrInput name="name" formControlName="one_diam_vnutrishnogo" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Стан придатків матки:</label>
          <input autocomplete="off"
                 [ngStyle]="{ 'font-size.px': options.fontSize }"
                 placeholder="" clrInput name="name" formControlName="one_stan_prudatkiv" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Особливості:</label>
          <input autocomplete="off"
                 [ngStyle]="{ 'font-size.px': options.fontSize }"
                 placeholder="" clrInput name="name" formControlName="one_osobluvosti" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row button-row">
      <div class="clr-col-sm-12 button-left">
         <button class="btn btn-primary" (click)="copyDataToTextArea('Величина плоду відповідає на  т.  д.', 'one_results')">Величина плоду відповідає на  т.  д.</button>
      </div>
      <div class="clr-col-sm-12 full-width-input">
        <clr-textarea-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Висновок УЗД:</label>
          <textarea [ngStyle]="{ 'font-size.px': options.fontSize }" clrTextarea name="description" formControlName="one_results"></textarea>
        </clr-textarea-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <app-doctors [parentForm]="form" [fontSize]="options.fontSize"></app-doctors>
      </div>
    </div>

    <div class="clr-row">
      <div class="print-block"></div>
    </div>

  </form>
</div>

<app-blank-actions
  [font]="options.fontSize"
  (print)="printCurrentPage()"
  (fontSize)="updateFontSize($event)">
</app-blank-actions>
